<template>
	<v-dialog v-model="selectCameraDialog" width="700">
    <customDialog>
      <template v-slot:title>
        {{t('searchCamera')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="selectCameraDialog = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0 pb-2" justify="start">
				      <v-col class="ma-0 pa-0" cols="12" id="store_list">
                <v-col class="ma-0 pa-0 pl-1 pr-1" cols="12">
							    <template v-if="loading == false">
										<template v-if="cameraList.length > 0">
											<v-row class="ma-0 pa-0" align="center">
												<v-col class="ma-0 pa-0 pr-2" cols="auto"
													v-for="item, index in cameraList" :key="index">
													<v-col v-if="item.isOnline" id="camera_thumbnail" class="ma-0 pa-0 mb-2" 
														cols="auto" @click="selectCamera(item)">
														<v-img :src="item.thumbnail"
															id="camera_image">
														</v-img>
														<v-col class="ma-0 pa-0" cols="auto" id="camera_name">
															{{item.cameraName}}
														</v-col>
													</v-col>
													<v-col v-else id="camera_thumbnail" class="ma-0 pa-0 mb-2" cols="auto"
														@click="selectCamera(item)">
														<v-img :src="require(`@/assets/images/grey_box.png`)"
															id="camera_image">
														</v-img>
														<v-col class="ma-0 pa-0" cols="auto" id="camera_name">
															<span>{{item.cameraName}}</span>
														</v-col>
													</v-col>
												</v-col>
											</v-row>
										</template>
										<template v-else>
											<v-col class="ma-0 pa-12" cols="12">{{t('noCamera')}}</v-col>
										</template>
                  </template>
                  <template v-else>
								    <v-row class="ma-0 pa-0" justify="start">
								    	<v-col class="ma-0 pa-0 pr-2 mb-2" cols="auto" align="center"
												v-for="item in 8" :key="item">
												<v-skeleton-loader :boilerplate="false" elevation="0" dark 
													type="image" width="7.5rem" height="5rem"
												></v-skeleton-loader>
											</v-col>
								    </v-row>
                  </template>
					      </v-col>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 pt-2 pb-2" align="center" justify="center">
              <v-btn class="ma-0 pa-0" width="8rem" height="2rem" id="grey_btn" 
								@click="selectCameraDialog = false">{{t('back')}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog> 
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean,
	},
	components: {
		customDialog
	},
	mixins: [mixin.common],
	data: () => ({
		selectCameraDialog: false,
		loading: false,
		cameraList: [],
	}),
	watch: {
		dialogVisible: function(item) {
			this.selectCameraDialog = item;
		},
		selectCameraDialog: function(item) {
			this.$emit('visible', item);
			if(item) this.getCameraList();
		},
	},
  mounted() {
    
  },
	methods: {
    getCameraList() {
			this.loading = true;
			const unisCustomerCd = this.$store.getters.getUserunisCustomerCd;
			this.networkController.getStoreCameraList({}, unisCustomerCd, '', '', '', '', '')
			.then((res) => {
        console.log('%cCameraList\n', "color:#008DD0;", res.data);
				this.cameraList = [...res.data];
				this.loading = false;
			}).catch(error => {
				this.loading = false;
			});
		},
		selectCamera(camera) {
			this.$emit('selectCamera', camera);
      this.selectCameraDialog = false;
		},
	}
}
</script>

<style lang="scss" scoped>
#store_list {
  min-height: 350px;
  max-height: 350px;
  overflow: auto;
  text-align: left;
  color: white;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
.v-list {
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0
	}
}
#camera_thumbnail {
  position: relative;
	width: 7.5rem;
	cursor: pointer;
}
#camera_image {
  z-index: 22;
  height: 5rem;
}
#camera_name {
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  color: #A8A8A8;
  font-size: 0.8em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 25;
}
</style>